import React, { useState } from "react";
import { BASE_URL } from "../../constant/constant";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import Popover from "../../Layouts/Popover/Popover";

const OrganizationCard = ({ org, navigateToAppPage, openOrgEditModal, handleDelete, handleDownloadGroupsAndRoles }) => {
  const [anchorPoint, setAnchorPoint] = useState(null);

  return (
    <>
      <div
        className="app_item_box"
        key={org.id}
        style={{
          padding: "0px",
          cursor: "pointer",
          transition: "background-color 0.3s"
        }}
        onClick={() => navigateToAppPage(org)}
      >
        <div className="org_action">
          <div className="d_flex align_center justify_between">
            {org?.logo ? (
              <div
                className="org_logo_circle"
                style={{
                  backgroundImage: `url(${BASE_URL}/api/v1/public/${org.logo})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center"
                }}
              />
            ) : (
              <MaterialIcon name="deployed_code" className="org_logo_circle default_org_img" />
            )}
            <MaterialIcon
              name="more_horiz"
              className="builder_icon"
              onClick={(e) => {
                e.stopPropagation();
                const { left, top } = e.currentTarget.getBoundingClientRect();
                setAnchorPoint({ x: left, y: top, deflectX: -104, deflectY: 12 });
              }}
            />
            {anchorPoint && (
              <Popover anchorPoint={anchorPoint} onClose={() => setAnchorPoint(null)}>
                <OrganizationActionsPopover
                  org={org}
                  openOrgEditModal={openOrgEditModal}
                  handleDelete={handleDelete}
                  handleDownloadGroupsAndRoles={handleDownloadGroupsAndRoles}
                />
              </Popover>
            )}
          </div>
        </div>
        <div>
          <div className="app_item_title" style={{ padding: "0px 20px", width: "384px" }}>
            {org.name}
          </div>
          <div className="d_flex" style={{ padding: "4px 20px 20px 20px", justifyContent: "space-between" }}>
            <div>
              <label className="builder-light-text">{org.apps?.length} Apps</label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const OrganizationActionsPopover = ({ org, openOrgEditModal, handleDelete, handleDownloadGroupsAndRoles }) => {
  const orgActions = [
    {
      label: "Edit Org",
      icon: "edit",
      onClick: (e) => {
        e.stopPropagation();
        openOrgEditModal(e, {
          description: org.description,
          name: org.name,
          id: org.id,
          logo: org.logo,
          apps: org.apps
        });
      }
    },
    {
      label: "Download User Groups and Roles",
      icon: "download",
      onClick: (e) => {
        e.stopPropagation();
        handleDownloadGroupsAndRoles(org);
      }
    },
    {
      label: "Delete",
      icon: "delete",
      onClick: (e) => {
        e.stopPropagation();
        handleDelete(e, org);
      }
    }
  ];

  return (
    <div style={{ padding: "12px" }}>
      {orgActions.map((action, index) => (
        <div
          key={index}
          className={"hover_bg_gray d_flex align_center gap_2 cursor_pointer border_radius_medium px_3 py_2"}
          onClick={(e) => action.onClick(e)}
        >
          <MaterialIcon name={action.icon} className={"font_size_medium"} />
          <span>{action.label}</span>
        </div>
      ))}
    </div>
  );
};

export default OrganizationCard;
